<script setup>

import {APP} from "@/config/app";

defineProps({
  name: {
    type: String,
    default: "",
  },
  status: {
    type: String,
    default: "Pending"
  }
})

</script>

<template>
  <div
      class="mx-auto max-w-7xl flex flex-col md:flex-row gap-4 justify-between items-center px-2 xl:px-0 py-16"
      :class="[resultClient?.clientInfo?.externalReference === 'unknown' && resultClient?.clientInfo?.type === 'SELF_SELECT' ? 'invisible' : '']"
  >
    <h2 :class="[APP.MyWealthMode ? 'text-forest' : 'text-teal', 'dark:text-white']">Hello {{ name }}</h2>
    <p class="body-1-light text-off-black dark:text-white"><strong class="body-1-semi-bold">Customer reference: </strong>{{ status }}</p>

  </div>
</template>

<style scoped>

</style>